import { render } from "./ShoppingCartNew.vue?vue&type=template&id=7c978424"
import script from "./ShoppingCartNew.vue?vue&type=script&lang=js"
export * from "./ShoppingCartNew.vue?vue&type=script&lang=js"

import "./ShoppingCartNew.vue?vue&type=style&index=0&id=7c978424&lang=css"

import exportComponent from "C:\\Ecommerce\\Studio Sport\\ECM_HYBRID_STUDIO_SPORT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__